module.exports = __webpack_public_path__ + "img/Stickers-examenidiom.25d60b1.png";